document.addEventListener('DOMContentLoaded', function () {
  if (window.location.pathname === '/' || window.location.pathname === '/index') {
    const audio = new Audio('https://cdn.shopify.com/s/files/1/0651/1987/9233/files/the-world-is-yours.mp3?v=1745475716');
    audio.volume = 0;

    let playCount = 0;

    const fadeInAudio = () => {
      let vol = 0;
      audio.play();
      const fade = setInterval(() => {
        if (vol < 1) {
          vol += 0.05;
          audio.volume = Math.min(vol, 1);
        } else {
          clearInterval(fade);
        }
      }, 150);
    };

    const enableAudio = () => {
      fadeInAudio();
      document.removeEventListener('click', enableAudio);
    };

    audio.addEventListener('ended', () => {
      playCount++;
      if (playCount < 2) {
        audio.currentTime = 0;
        audio.play();
      }
    });

    document.addEventListener('click', enableAudio);
  }
});
